import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 346px;
  padding: 56px 73px 56px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background: ${themeStyle.varBrandSuperLight};
  border-radius: ${themeStyle.radiusMedium};
`;
